define('modules/form_editor/views/preview_custom_password',['require','exports','module','./preview_base','../../editor/models/editorstate','ldsh!../templates/preview_custom_password_amp','ldsh!../templates/preview_custom_password'],function(require, exports, module) {
  "use strict";
  var InputBase = require("./preview_base"),
    EditorState = require("../../editor/models/editorstate");

  module.exports = InputBase.extend({
    template: null,

    initialize: function(options) {
      this.template = EditorState.getAMPState() ?
        require("ldsh!../templates/preview_custom_password_amp") :
        require("ldsh!../templates/preview_custom_password");

      module.exports.__super__.initialize.apply(this, arguments);
    },

    helpers: function () {
      var suffix = '-confirmation',
        confirmation = this.model.get('confirmation'),
        elementId = this.model.get('elementId'),
        confirmationID = this.model.get('elementId') + suffix,
        confirmationName = this.model.get('nameAttr') + suffix;

      return {
        elementId: elementId,
        confirmation: confirmation,
        confirmationID: confirmationID,
        confirmationName: confirmationName
      };
    }
  });
});

